document.addEventListener('DOMContentLoaded', () => {

  const slider = document.getElementById('showcaseSlider');
  const items = document.querySelectorAll('.showcase-item');

  const prevBtn = document.querySelector('.prev');
  const nextBtn = document.querySelector('.next');

  const progress = document.querySelector('.progress-line span');

  const mainImage = document.getElementById('mainShowcaseImage');
  const mainTitle = document.getElementById('mainTitle');
  const mainDescription = document.getElementById('mainDescription');
  const mainButton = document.getElementById('mainButton');
  const reviewText = document.getElementById('reviewText');

  let currentIndex = 0;
  let sliderIndex = 0;

  function getVisibleItems() {
    if (window.innerWidth <= 480) return 1;
    if (window.innerWidth <= 768) return 2;
    return 3;
  }

  function updateSlider() {

    const gap = parseInt(getComputedStyle(slider).gap) || 0;

    const itemWidth = items[0].offsetWidth + gap;

    slider.style.transform =
      `translateX(-${sliderIndex * itemWidth}px)`;

    const percent =
      ((currentIndex + 1) / items.length) * 100;

    progress.style.width = `${percent}%`;
  }

  function updateContent(item) {

    mainImage.src = item.dataset.mainImage;
    mainTitle.innerHTML = item.dataset.title;
    mainDescription.innerHTML = item.dataset.description;
    mainButton.innerHTML = item.dataset.button;
    mainButton.href = item.dataset.link;
    reviewText.innerHTML = item.dataset.review;
  }

  function setActive(index) {

    currentIndex = index;

    items.forEach(item => item.classList.remove('active'));

    items[currentIndex].classList.add('active');

    updateContent(items[currentIndex]);

    const visible = getVisibleItems();
    const maxSliderIndex = items.length - visible;

    // mantener visible el item activo
    if (currentIndex < sliderIndex) {
      sliderIndex = currentIndex;
    }

    if (currentIndex >= sliderIndex + visible) {
      sliderIndex = currentIndex - visible + 1;
    }

    sliderIndex = Math.max(0, Math.min(sliderIndex, maxSliderIndex));

    updateSlider();
  }

  nextBtn.addEventListener('click', () => {

    if (currentIndex < items.length - 1) {
      setActive(currentIndex + 1);
    }

  });

  prevBtn.addEventListener('click', () => {

    if (currentIndex > 0) {
      setActive(currentIndex - 1);
    }

  });

  items.forEach((item, index) => {

    item.addEventListener('click', () => {
      setActive(index);
    });

  });

  window.addEventListener('resize', () => {

    sliderIndex = 0;
    setActive(currentIndex);

  });

  setActive(0);

});